import React, { useRef } from 'react';
import {
    Area, FlexRow, FlexColumn, Title, RedStripe, RedTextTitle, BlueText, MoreInfo,
    ArrowCircleIcon, HandIcon, TaxesRefundedTitle, TaxesRefunded, Space,
    TaxesSubTitle, TaxesSubText, TaxRefundListItem, TaxRefundLITitle, FlexRowFull,
    TaxRefundLIText, MoreInfoMobile,TaxRefundCTAlink
} from './index.style';

const alignItemsCenter = { alignItems: 'center' };

const TaxRefunds = ({ ctaBtnTitle, ctaBtnLink, taxRefundsEl, taxRefunds: {
    segmentTitle, taxesRefundTitle, clientsTaxesTitle, quickProcessTitle, quickProcessText,
    title, fullText, moreInfo, taxesRefund, clientsTaxes, list1, list2, list3, cta,
} }) => {
    const moreInfoEl = useRef(null);
    console.log('ctaBtnLink', ctaBtnLink);
    console.log('ctaBtnTitle', ctaBtnTitle);
    const clickMoreInfo = () => moreInfoEl.current.click();
    return (<Area ref={taxRefundsEl}>
        <FlexRow style={{ marginBottom: '68px' }}>
            <FlexColumn>
                <Title onClick={clickMoreInfo}>
                    <RedStripe />
                    {segmentTitle.text}
                </Title>
                {!!title &&
                    <RedTextTitle onClick={clickMoreInfo}>{title.text}</RedTextTitle>}
                {!!fullText &&
                    <BlueText onClick={clickMoreInfo}>{fullText.text}</BlueText>}
                {!!moreInfo &&
                    <MoreInfo
                        ref={moreInfoEl}
                        to='/taxes'
                        hidemobile={'true'}
                    >
                        {moreInfo.text}
                        <ArrowCircleIcon />
                    </MoreInfo>}
            </FlexColumn>
            <FlexColumn style={alignItemsCenter}>
                <HandIcon />
                <TaxesRefundedTitle>{taxesRefundTitle.text}</TaxesRefundedTitle>
                {!!taxesRefund && <TaxesRefunded>
                    {taxesRefund.number.toLocaleString()}
                    <Space>ש״ח</Space>
                </TaxesRefunded>}
                <FlexRowFull>
                    {!!clientsTaxes && <FlexColumn style={alignItemsCenter}>
                        <TaxesSubTitle>{clientsTaxesTitle.text}</TaxesSubTitle>
                        <TaxesSubText>{clientsTaxes.number.toLocaleString()}</TaxesSubText>
                    </FlexColumn>}
                    <FlexColumn style={alignItemsCenter}>
                        <TaxesSubTitle>{quickProcessTitle.text}</TaxesSubTitle>
                        <TaxesSubText>{quickProcessText.text}</TaxesSubText>
                    </FlexColumn>
                </FlexRowFull>
                {!!moreInfo &&
                    <MoreInfoMobile to='/taxes'>
                        {moreInfo.text}
                        <ArrowCircleIcon />
                    </MoreInfoMobile>}
            </FlexColumn>
        </FlexRow>
        <FlexRow style={{ justifyContent: 'space-between', marginBottom: '60px' }}>
            <TaxRefundListItem>
                <TaxRefundLITitle>
                    <RedStripe />
                    {list1.title.text}
                </TaxRefundLITitle>
                <TaxRefundLIText>
                    {list1.text.text}
                </TaxRefundLIText>
            </TaxRefundListItem>
            <TaxRefundListItem>
                <TaxRefundLITitle>
                    <RedStripe />
                    {list2.title.text}
                </TaxRefundLITitle>
                <TaxRefundLIText>
                    {list2.text.text}
                </TaxRefundLIText>
            </TaxRefundListItem>
            <TaxRefundListItem>
                <TaxRefundLITitle>
                    <RedStripe />
                    {list3.title.text}
                </TaxRefundLITitle>
                <TaxRefundLIText>
                    {list3.text.text}
                </TaxRefundLIText>
            </TaxRefundListItem>
        </FlexRow>
        {/* {!!cta && <TaxRefundCTAlink href={ctaBtnLink.text} target='_new'>{cta.text}</TaxRefundCTAlink>} */}
        {!!cta && <TaxRefundCTAlink href={ctaBtnLink?.text} target='_new'>{ctaBtnTitle?.text}</TaxRefundCTAlink>}
    </Area>);
};

export default TaxRefunds;